import { useNavigate } from "react-router-dom";
import Navbar from "@/components/Navbar";
import { ArrowLeft } from "lucide-react";

export default function Legal() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="max-w-2xl mx-auto px-5 sm:px-8 pt-8 pb-24">
        <button onClick={() => navigate(-1)} data-testid="legal-back" className="flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground mb-8">
          <ArrowLeft className="w-4 h-4" /> Back
        </button>

        <section id="privacy" className="mb-14">
          <h1 className="font-serif text-4xl tracking-tight mb-4">Privacy Policy</h1>
          <div className="space-y-4 text-sm text-muted-foreground leading-relaxed">
            <p>Xcelio is a personal social-confidence coach. We collect only what we need to give you a great experience: your name, email, the goals and reflections you share, and how you use the app.</p>
            <p>Your conversations are used to personalise your coaching. We never sell your data. Voice recordings are processed to transcribe and respond, and are not shared with third parties beyond the AI providers that power the coach.</p>
            <p>You can request deletion of your account and data anytime by emailing <a href="mailto:bookings@michaelmuller.co.uk" className="text-primary">bookings@michaelmuller.co.uk</a>.</p>
          </div>
        </section>

        <section id="terms">
          <h1 className="font-serif text-4xl tracking-tight mb-4">Terms &amp; Conditions</h1>
          <div className="space-y-4 text-sm text-muted-foreground leading-relaxed">
            <p>By using Xcelio you agree to use it for personal growth and practice. Xcelio is a coaching tool, not a substitute for professional mental-health care.</p>
            <p>Premium subscriptions renew automatically until cancelled. You can cancel anytime from Settings → Manage plan and keep access until the end of your billing period.</p>
            <p>Talk time and premium allowances are provided on a fair-use basis and may adjust over time. Questions? Email <a href="mailto:bookings@michaelmuller.co.uk" className="text-primary">bookings@michaelmuller.co.uk</a>.</p>
          </div>
        </section>
      </main>
    </div>
  );
}
